import styled from "styled-components";

const StyledButton = styled.button`
  margin: 0;
  padding: 0.75rem 1.5rem;
  cursor: pointer;
  background-color: #64da4c;
  color: #001f52;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.95rem;
  line-height: 1.5;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(100, 218, 76, 0.3);

  &:hover {
    background-color: #4fc738;
    transform: translateY(-1px);
    box-shadow: 0 4px 8px rgba(100, 218, 76, 0.4);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(100, 218, 76, 0.3);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }
`;

export default StyledButton;